import { onDarkBase } from "@biom3/design-tokens";
import type { Theme } from "@mui/material";

export default function getChipOverrides(theme: Theme) {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
        },
        colorSecondary: {
          backgroundColor: onDarkBase.color.translucent.inverse[600],
          color: theme.palette.text.primary,
          border: `1px solid ${onDarkBase.color.translucent.standard[500]}`,
        },
      },
    },
  };
}
